// WP-A · status banner shown after a successful submit or on an unexpected error.
export function Status({ kind, children }) {
  if (!children) return null;
  return <div class={`status status-${kind || "ok"}`}>{children}</div>;
}
